<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="公众号">
              <a-select
                placeholder="请选择渠道"
                option-filter-prop="children"
                v-model="queryParam.appId"
                @change="handleChange"
              >
                >
                <a-select-option
                  v-for="item in wechatApp"
                  :key="item.appId"
                  :value="item.appId"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="标题">
              <a-input
                placeholder="输入标题模糊查询"
                v-model="queryParam.title"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a-button
                type="primary"
                @click="syncWxTemplate"
                icon="search"
                style="margin-left: 8px"
                v-has="'wechat:msgtemplate:syncWxTemplate'"
                >同步公众号模板</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-dropdown v-if="false">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="openFlag" slot-scope="text, record">
          {{ record.openFlag == '1' ? '有效' : '无效' }}
        </template>
        <template slot="content" slot-scope="text, record">
          <p :title="record.content">
            {{
              record.content.length > 20
                ? record.content.substring(0, 20) + '...'
                : record.content
            }}
          </p>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="templateConfig(record)">配置</a>&nbsp;&nbsp;
          <a @click="sendTemplate(record)">推送</a>&nbsp;&nbsp;
          <a @click="removeTemplate(record)">删除</a>
        </span>
      </a-table>
    </div>

    <a-modal v-model="dialog.sendTemplate" title="推送模板消息" width="700px">
      <template slot="footer">
        <a-button key="back" @click="dialog.sendTemplate = false"
          >取消</a-button
        >
        <a-button type="primary" @click="sendTemplateOkay">确定发送</a-button>
      </template>
      <div>
        <a-form
          layout="horizontal"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-item label="标题">
            <a-input v-model="templateConfigData.title" disabled="disabled" />
          </a-form-item>
          <a-form-item label="链接">
            <a-input v-model="templateConfigData.url" />
          </a-form-item>
          <a-form-item label="小程序appid">
            <a-input v-model="templateConfigData.miniprogram.appid" />
          </a-form-item>
          <a-form-item label="小程序路径">
            <a-input v-model="templateConfigData.miniprogram.pagePath" />
          </a-form-item>
          <a-form-item label="推送设置">
            <a-radio-group v-model="templateConfigData.sendRule">
              <a-radio :value="0"> 全部用户 </a-radio>
              <a-radio :value="1"> 指定用户 </a-radio>
              <!-- <a-radio :value="3">
                分组用户
              </a-radio> -->
            </a-radio-group>
          </a-form-item>
          <a-form-item
            label="接收用户"
            v-if="this.templateConfigData.sendRule === 1"
          >
            <a-input
              v-model="templateConfigData.openId"
              placeholder="接收用户OpenId"
            />
          </a-form-item>
          <a-form-item
            label="分组用户"
            v-if="this.templateConfigData.sendRule === 3"
          >
            <a-select v-model="templateConfigData.tagId">
              <a-select-option
                v-for="item in tagListAll"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <div style="border: 1px dashed #aaa">
            <a-form-item
              v-for="item in templateConfigData.data"
              :label="item.name"
              :key="item.name"
            >
              <a-row :gutter="24">
                <a-col :span="10">
                  <a-input v-model="item.value" placeholder="" />
                </a-col>
                <a-col :span="14">
                  颜色<a-input
                    v-model="item.color"
                    style="width: auto; margin-left: 20px"
                  />
                </a-col>
              </a-row>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </a-modal>
    <templateModal ref="modalForm" @ok="getList()"></templateModal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import templateModal from './modules/templateModal.vue';
import { getAction, putAction, postAction, postTag } from '@/api/manage';

export default {
  name: 'msg-template',
  components: {
    templateModal,
  },
  data() {
    return {
      dataSource: [],
      appId: '',
      selectedRowKeys: [],
      form: this.$form.createForm(this),
      dialog: {
        templateConfig: false,
        sendTemplate: false,
      },
      loading: false,

      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      templateConfigData: { miniprogram: {}, data: [] },
      queryParam: {
        appId: '',
      },
      wechatApp: [],
      tagListAll: [],
      // 表头
      columns: [
        {
          title: '模板ID',
          align: 'center',
          dataIndex: 'templateId',
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title',
        },
        {
          title: '模板名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '模板字段',
          align: 'center',
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' },
        },
        {
          title: '是否有效',
          align: 'center',
          dataIndex: 'openFlag',
          scopedSlots: { customRender: 'openFlag' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/list',
        delete: process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/delete',
      },
    };
  },
  created() {
    this.getWechatApp();
  },

  methods: {
    handleChange(value) {
      console.warn(value);
      this.queryParam.appId = value;
    },
    searchQuery() {
      this.getList(1);
    },
    getList(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      let params = this.queryParam;

      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2',
      }).then((res) => {
        if (res.success) {
          this.queryParam.appId = res.result[0].appId;
          this.appId = res.result[0].appId;
          this.wechatApp = res.result;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    searchReset() {
      this.queryParam.title = '';
      this.queryParam.appId = this.appId;
      this.getList();
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      this.ipagination = pagination;
      this.getList({
        pageNo: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
    syncWxTemplate() {
      if (!this.queryParam.appId) {
        this.$message.warn('请选择公众号');
        return;
      }
      postAction(
        process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/syncWxTemplate',
        { appId: this.queryParam.appId }
      ).then((res) => {
        if (res.success) {
          this.wechatApp = res.result;
          this.getList(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    templateConfig(row) {
      this.$refs.modalForm.templateOpen(row);
    },
    removeTemplate(row) {
      let that = this;
      this.$confirm({
        title: '删除模板',
        content: '你确定要删除这个模板吗？',
        onOk() {
          postAction(process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/remove', {
            id: row.id,
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.getList(1);
              that.$message.success('删除成功');
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    templateConfigOkay() {
      if (!this.validForm(1)) {
        return false;
      }
      let data = { ...this.templateConfigData };
      if (data.openFlag) {
        data.openFlag = '1';
      } else {
        data.openFlag = '0';
      }
      data.data = JSON.stringify(data.data);
      data.miniprogram = JSON.stringify(data.miniprogram);
      putAction(
        process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/edit',
        data
      ).then((res) => {
        if (res.success) {
          this.$message.success('修改成功');
          this.getList(1);
          this.dialog.templateConfig = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    radioChange(e) {
      this.templateConfigData.sendRule = e.target.value;
      console.log(
        'this.templateConfigData.sendRule',
        this.templateConfigData.sendRule
      );
      console.log('v', e.target.value);
    },
    sendTemplate(row) {
      this.templateConfigData = { ...row, sendRule: 0 };
      if (!this.templateConfigData.miniprogram) {
        this.templateConfigData.miniprogram = { appid: '', pagePath: '' };
      } else {
        this.templateConfigData.miniprogram = JSON.parse(
          this.templateConfigData.miniprogram
        );
      }
      if (
        !this.templateConfigData.data ||
        this.templateConfigData.data.length == 0
      ) {
        this.templateConfigData.data = [];
        let keysArray =
          this.templateConfigData.content.match(/\{\{(\w*)\.DATA\}\}/g) || [];
        keysArray.map((item) => {
          let name = item.replace('{{', '').replace('.DATA}}', '');
          this.templateConfigData.data.push({
            name: name,
            value: '',
            color: '#000000',
          });
        });
      } else {
        this.templateConfigData.data = JSON.parse(this.templateConfigData.data);
      }
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll', {
        appid: this.queryParam.appId,
      }).then((res) => {
        if (res.success && res.code === 200) {
          this.tagListAll = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
      console.log(this.tagListAll);
      this.dialog.sendTemplate = true;
    },
    sendTemplateOkay() {
      if (!this.validForm(2)) {
        return false;
      }
      let data = { ...this.templateConfigData };
      data.data = JSON.stringify(data.data);
      data.miniprogram = JSON.stringify(data.miniprogram);
      if (data.sendRule === 0 || !data.sendRule) {
        data.allFlag = '1';
      } else {
        data.allFlag = '';
      }
      if (data.tagId) {
        data.appId = this.queryParam.appId;
      }
      postTag(
        process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/sendTemplate',
        data
      ).then((res) => {
        if (res.success) {
          this.$message.success('发送成功');
          this.dialog.sendTemplate = false;

          this.getList(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    validForm(type) {
      if (!this.templateConfigData.name) {
        this.$message.warn('请输入模版名称');
        return false;
      }
      if (this.templateConfigData.data.length > 0) {
        for (let index in this.templateConfigData.data) {
          let item = this.templateConfigData.data[index];
          /*if (item.value == undefined || item.value == null || item.value == '' ) {
              this.$message.warn('请输入' + item.name)
              return false
            }*/
          if (!item.color) {
            this.$message.warn('请输入' + item.name + '的颜色');
            return false;
          }
        }
      }
      if (this.templateConfigData.sendRule === 1) {
        if (type == 2 && !this.templateConfigData.openId) {
          this.$message.warn('请选择推送用户');
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
